module.exports = __webpack_public_path__ + "assets/9b88f78a1dc75a6cead23ad17b49fe32.png";